<template>
  <v-dialog
    v-model="dialog"
    persistent
    :max-width="options.width"
  >
    <v-card dense flat>
      <v-card-title class="headline">
        {{title}}
      </v-card-title>
      <v-card-text v-html="message"></v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey" text @click.native="clickCancel()">
          キャンセル
        </v-btn>
        <v-btn color="primary" @click.native="clickOK()">
          OK
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data () {
    return {
      dialog: false,
      resolve: null,
      reject: null,
      message: null,
      title: null,
      options: {
        width: 400
        // 下記のようなパラメータ、適宜自由に追加してOK
        // color: "grey lighten-3",
        // zIndex: 200,
        // noconfirm: false
      }
    }
  },
  methods: {
    open (title, message, options) {
      this.dialog = true
      this.title = title
      this.message = message
      this.options = Object.assign(this.options, options)
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    clickCancel () {
      this.resolve(false)
      this.dialog = false
    },
    clickOK () {
      this.resolve(true)
      this.dialog = false
    }
  }
}
</script>
